import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

interface FAQItem {
  question: string;
  answer: string;
}

interface FormationFAQProps {
  faqs?: FAQItem[];
}

export function FormationFAQ({ faqs }: FormationFAQProps) {
  const { t } = useTranslation('formationDetail');

  // Utiliser les FAQs passées en props ou celles des traductions par défaut
  const faqItems = faqs || (t('faq.items', { returnObjects: true }) as FAQItem[]);
  const faqTitle = t('faq.title');

  // Schema.org FAQPage pour SEO
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      {/* Schema.org FAQPage */}
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
    <section className="py-24 bg-aspexit-gray-light">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-heading font-extrabold text-aspexit-black mb-8 text-center">
            {faqTitle}
          </h2>

          <div className="space-y-4">
            {faqItems.map((faq, index) => (
              <div
                key={index}
                className="bg-white border-l-4 border-aspexit-red rounded-lg p-6 shadow-sm"
              >
                <h3 className="text-lg font-heading font-semibold text-aspexit-black mb-3 flex items-start gap-2">
                  <span className="text-aspexit-red flex-shrink-0">❓</span>
                  {faq.question}
                </h3>
                <p className="text-aspexit-gray leading-relaxed pl-7">
                  <span className="text-aspexit-red font-semibold">→</span>{' '}
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
